import { render } from "./FbnUploadProof.vue?vue&type=template&id=c61abb22"
import script from "./FbnUploadProof.vue?vue&type=script&lang=js"
export * from "./FbnUploadProof.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__